import {useEffect, useState} from "react";
import {Fetch} from "helpers/fetchWrapper";
import {useCancellablePromise} from "helpers/promiseHandler";

const STATUS = {
    LOADING: "loading",
    SUCCESS: "success",
    ERROR: "error",
};

const manageStores = {
    _url: `${process.env.REACT_APP_RESTAURANT_MENU_URL}`,

    GetAllStores(searchQuery, refetch) {
        const [stores, setStores] = useState({
            stores: [],
            totalItems: 0,
        });
        const {cancellablePromise} = useCancellablePromise();
        const [status, setStatus] = useState(STATUS.LOADING);
        useEffect(() => {
            setStatus(STATUS.LOADING);
            cancellablePromise(this.getAllStore(searchQuery))
                .then(res => {
                    setStores(() => res);
                    console.log({res});
                    setStatus(STATUS.SUCCESS);
                })
                .catch(() => setStatus(STATUS.ERROR));
        }, [JSON.stringify(searchQuery), refetch, searchQuery?.searchText]);
        return {
            stores_loading: status === STATUS.LOADING,
            stores_error: status === STATUS.ERROR ? status : "",
            stores_data: stores,
        };
    },

    GetCuisines(searchQuery, refetch) {
        const [cuisines, setCuisines] = useState({
            cuisines: [],
            totalItems: 0,
        });
        const {cancellablePromise} = useCancellablePromise();
        const [status, setStatus] = useState(STATUS.LOADING);
        useEffect(() => {
            setStatus(STATUS.LOADING);
            cancellablePromise(this.getCuisines(searchQuery))
                .then(res => {
                    setCuisines(() => res);
                    setStatus(STATUS.SUCCESS);
                })
                .catch(() => setStatus(STATUS.ERROR));
        }, [JSON.stringify(searchQuery), refetch]);
        return {
            cuisine_loading: status === STATUS.LOADING,
            cuisine_error: status === STATUS.ERROR ? status : "",
            cuisine_data: cuisines,
        };
    },

    async getAllStore({page = 1, pageSize = 10, searchText = "", businessId, getAll = false}) {
        let res = await Fetch.get(
            `${this._url}/stores/get-all-stores/${businessId}?itemsPerPage=${pageSize}&page=${page}&searchText=${searchText}&getAll=${getAll}`
        );
        if (res.status >= 200 && res.status < 300) {
            res = await res.json();

            return {
                stores: res?.data?.items,
                totalItems: res?.data?.totalItems,
            };
        }
        const {message} = await res.json();
        throw new Error(message ?? "Something went wrong");
    },

    async createStore(payload) {
        let res = await Fetch.upload(`${this._url}/stores/create`, "POST", payload);
        if (res.status >= 200 && res.status < 300) {
            res = await res.json();
            return res;
        }
        const {message} = await res.json();
        throw new Error(message ?? "Something went wrong");
    },

    async getStoresForCopy(businessId) {
        let res = await Fetch.get(`${this._url}/stores/get-all-stores/${businessId}?getAll=true`);
        if (res.status >= 200 && res.status < 300) {
            res = await res.json();
            return {
                stores: res?.data?.items || [],
                totalItems: res?.data?.totalItems || 0,
            };
        }
        const {message} = await res.json();
        throw new Error(message ?? "Something went wrong");
    },
    async editStore(id, payload) {
        let res = await Fetch.upload(`${this._url}/stores/updateOne/${id}`, "PUT", payload);
        if (res.status >= 200 && res.status < 300) {
            res = await res.json();
            return res;
        }
        const {message} = await res.json();
        throw new Error(message ?? "Something went wrong");
    },
    async deleteStore(id) {
        let res = await Fetch.delete(`${this._url}/stores/deleteOne/${id}`);
        if (res.status >= 200 && res.status < 300) {
            res = await res.json();
            return res;
        }
        const {message} = await res.json();
        throw new Error(message ?? "Something went wrong");
    },

    async getCuisines({page = 1, pageSize = 10, searchText, startDate, endDate, getAll = false}) {
        let res = await Fetch.get(
            `${this._url}/stores/cuisines?itemsPerPage=${pageSize}&page=${page}&searchText=${searchText}&startDate=${startDate}&endDate=${endDate}&getAll=${getAll}`
        );
        if (res.status >= 200 && res.status < 300) {
            res = await res.json();
            return {
                cuisines: res.items,
                totalItems: res.totalItems,
            };
        }
        const {message} = await res.json();
        throw new Error(message ?? "Something went wrong");
    },

    async copyMenuToBranch(payload) {
        let res = await Fetch.post(`${this._url}/stores/copy-menu`, payload);
        if (res.status >= 200 && res.status < 300) {
            res = await res.json();
            return res;
        }
        const {message} = await res.json();
        throw new Error(message ?? "Something went wrong");
    },
};

export default manageStores;
